export default {
  setMusics(state, musics) {
    state.musics = musics;
  },
  setRepertories(state, repertories) {
    state.repertories = repertories;
  },
  setCountMusics(state, count) {
    state.count = count;
  },
  setThemes(state, themes) {
    state.themes = themes;
  }
};
